import { render, staticRenderFns } from "./AlternativeCreation.vue?vue&type=template&id=243bbba6"
import script from "./AlternativeCreation.vue?vue&type=script&lang=js"
export * from "./AlternativeCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports